var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"h1 font-weight-bold text-dark"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('front-product-list',{attrs:{"category-id":_vm.categoryId}}),_vm._v(" "),_vm._l((_vm.children),function(child,index){return (_vm.deep)?_c('front-category-shower',{key:index,attrs:{"category-id":child.id}}):_vm._e()})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }